module.exports = __webpack_public_path__ + "static/home-hero-video-2800x1000-edaa6f9feb265ec88044c2540744047e.mp4";